export class Evento{
  id: number;
  nome: string;
  descricao: string;
  datalimit: any;
  datalimitsub: any;
  datainicio: any;
  cod_evento:any;
  imagem:any;
  liberado:boolean;
  curso:boolean;
  max_trab:number;
  trabalho:boolean;
  inscrito: boolean;
}



// WEBPACK FOOTER //
// ./src/app/eventos/evento.ts